import { all } from "@redux-saga/core/effects";

import { queuesEntriesSagas } from "modules/Queues/services/Queues/sagas";

export function* queuesSaga() {
    yield all([
        queuesEntriesSagas()
    ]);
}